import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <img src="PACONERPlogoletra.png" alt="Logo PACON ERP" className="logo-img" />
        </div>

        {/* Navegación Desktop */}
        <nav className="nav-desktop">
          <ul className="nav-list">
            <li><a href="#inicio" className="nav-link">Inicio</a></li>
            <li><a href="#servicios" className="nav-link">Servicios</a></li>
            <li><a href="#productos" className="nav-link">Productos</a></li>
            <li><a href="#nosotros" className="nav-link">Nosotros</a></li>
            <li><a href="#contacto" className="nav-link">Contacto</a></li>
          </ul>
        </nav>

        {/* Botón Contacto */}
        <div className="header-cta">
          <button className="btn-contact">Consulta Factura Electrónica</button>
        </div>

        {/* Menú Móvil */}
        <button className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="hamburger"></span>
        </button>

        {/* Navegación Móvil */}
        <nav className={`nav-mobile ${isMenuOpen ? 'nav-mobile-open' : ''}`}>
          <ul className="nav-mobile-list">
            <li><a href="#inicio" className="nav-mobile-link">Inicio</a></li>
            <li><a href="#servicios" className="nav-mobile-link">Servicios</a></li>
            <li><a href="#productos" className="nav-mobile-link">Productos</a></li>
            <li><a href="#nosotros" className="nav-mobile-link">Nosotros</a></li>
            <li><a href="#contacto" className="nav-mobile-link">Contacto</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 